module.exports = __webpack_public_path__ + "img/enemy_111_001.8bb69e5a.png";